// cSpell:ignore flexbox, STYuanti, Unmount

import React from 'react';
import styled from 'styled-components';

import LessonCard from './lesson-card';
import { Flex, UnitGuide } from '../../lib/components/LessonPath/static/style';
import { COURSE_TYPE } from '../../lib/components/LessonPath/static/json/constant';
import { specialCourse } from '../../server/commonFun';

export default class Lessons extends React.Component {
    constructor(props) {
        super(props);

        this.state = { activeCid: window.localStorage.getItem('activeCid') }      // 存储当前鼠标滑过的那一个
    }

    componentDidMount() {
        const that = this;
        window.addEventListener('mousewheel', that.onScrollHandler);
        window.addEventListener('DOMMouseScroll', that.onScrollHandler);
    }

    componentWillUnmount() {
        const that = this;
        window.removeEventListener('mousewheel', that.onScrollHandler);
        window.removeEventListener('DOMMouseScroll', that.onScrollHandler);
    }

    // 卡片鼠标经过的事件（存储当前鼠标经过的位置）
    mouseOverHandler(cid) {
        this.setState({
            activeCid: cid
        });

        window.localStorage.setItem('activeCid', cid);
    }

    // 监听滚动事件（鼠标上下滚动时，列表左右滚动）
    onScrollHandler = e => {
        const that = this;
        const { cid } = that.props;

        // 判断是否处于学习列表
        if (cid) {
            return;
        }
        var lessonListElement = this.refs.lessonBox;

        if (lessonListElement) {
            if (/(macintosh).*(mac os x)/i.test(navigator.userAgent.toLocaleLowerCase())) {
                lessonListElement.scrollLeft += e.wheelDeltaY / 2;
            } else {
                lessonListElement.scrollLeft += -e.wheelDeltaY / 2;
            }
        }
    };

    // 是否显示上一单元和下一单元
    showToggleUnitHandler(direction) {
        const { unitInfo } = this.props;

        if (!(unitInfo && unitInfo.unit && unitInfo.unitNum)) {
            return false;
        }

        if (direction > 0) {
            // 是否显示下一单元： unit 不是 unit 的最大值 || level 不是 level 的最大值
            return (unitInfo.unit < unitInfo.unitNum || unitInfo.level < unitInfo.levelNum) ? true : false;
        } else if (direction < 0) {
            // 是否显示上一单元: unit 不小于1 || level 不小于 0（现在有 level 0，也就是 level K）
            return (unitInfo.unit > 1 || (unitInfo.level > 0 && !specialCourse(unitInfo.level))) ? true : false;
        }
    }

    render() {
        const { lessonData, unitInfo } = this.props;
        const { activeCid } = this.state;

        return (
            <LessonBox ref='lessonBox' id='lessons-list-box'>
                <LessonContainer>
                    <PlaceholderCard />
                    {this.showToggleUnitHandler(-1) &&
                        <UnitGuideRow direction={-1}
                            onClick={() => this.props.clickToggleUnitHandler(-1)}
                        />
                    }
                    {lessonData &&
                        lessonData.nodes &&
                        Array.isArray(lessonData.nodes) &&
                        lessonData.nodes.map((value, index) =>
                            value && value.nodeType &&
                                (value.nodeType === COURSE_TYPE.majorLesson
                                    || value.nodeType === COURSE_TYPE.trialLesson
                                    || value.nodeType === COURSE_TYPE.ctLesson
                                    || value.nodeType === COURSE_TYPE.readingLesson
                                    || value.nodeType === COURSE_TYPE.expandLesson
                                    || value.nodeType === COURSE_TYPE.web
                                    || value.nodeType === COURSE_TYPE.KETLesson
                                )
                                ? <LessonCard key={index}
                                    data={
                                        Object.assign(
                                            {}, value,
                                            {
                                                index: index,
                                                currentCid: lessonData.cid ? lessonData.cid : 0,
                                                level: unitInfo.level || 0
                                            }
                                        )
                                    }
                                    activeCid={activeCid}
                                    onMouseOver={this.mouseOverHandler.bind(this)}
                                />
                                : null)
                    }
                    {this.showToggleUnitHandler(1) &&
                        <UnitGuideRow direction={1}
                            onClick={() => this.props.clickToggleUnitHandler(1)}
                        />
                    }
                    <PlaceholderCard />
                </LessonContainer>
            </LessonBox>
        );
    }
}

const LessonBox = styled(Flex)`
    width: 100%;
    /* height: 60%; */
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
        width: 0 !important;
    }
`;

// 前后占位的卡片 否则左右的边距太小
const PlaceholderCard = styled.div`
    height: 100%;
    width: 2.2rem;
`;

const UnitGuideRow = styled(UnitGuide)`
    flex: none;
    margin: 6rem 0.8rem 0;
`;

const LessonContainer = styled(Flex)``;

// case .trialLesson, .major
// 预习、学习、练一练、学习报告

// case .ctLesson
// 单元总结、学习、学习报告

// case .expandLesson
// 学习、练一练、学习报告

// case .readingLesson
// 预习、学习、练一练、学习报告


// WEBPACK FOOTER //
// ./src/components/lesson-path/lesson-box.js